import React from "react";
import * as Image from "../../../../../common-deprecated/styles/lexus/Image";
import * as Dropdown from "../../../../../common-deprecated/styles/v2/lexus/globals/Dropdown";
import Preloader from "../../../../../common-deprecated/styles/lexus/Preloader";
import { useCompareV2Selector } from "../../../redux/store";
import { getCompareImages } from "../../../../../shared-logic/features/compare/utils/helpers";
import EmptySlot from "./content/EmptySlot";
import SelectSwatch from "./SelectSwatch";
import * as CompareItemStyles from "../styles/CompareItem";
import HighlightedSpecs from "./HighlightedSpecs";
import { getCarName } from "../../../utils/formatters/nameFormatters";
import useCompareDetails from "../../../../../shared-logic/features/compare/hooks/useCompareDetails";
import CompareTable from "../../common/CompareTable";

const CompareDetails = (props: { isPdf?: boolean }): JSX.Element => {
    const { isPdf = false } = props;
    const cars = useCompareV2Selector((state) => state.newCarCompare.grades);
    const commonSettings = useCompareV2Selector((state) => state.commonSettings);

    const { placeholderImage, swatchSelectHeight, setSwatchSelectHeight, engineSelectHeight, setEngineSelectHeight } =
        useCompareDetails(isPdf, cars, commonSettings);

    return (
        <CompareTable
            items={cars}
            placeholder={() =>
                !isPdf && (
                    <CompareItemStyles.Wrapper>
                        <EmptySlot carImage={placeholderImage} />
                    </CompareItemStyles.Wrapper>
                )
            }
            columnChild={(car, index) => {
                const image = getCompareImages(car, commonSettings);
                return (
                    <CompareItemStyles.Wrapper>
                        {isPdf && (
                            <Dropdown.Title isPdf={isPdf} showPointer={false} height={60}>
                                {getCarName(car, commonSettings)}
                            </Dropdown.Title>
                        )}
                        <CompareItemStyles.Placeholder isLoading={car.loading}>
                            {car.loading ? (
                                <Preloader />
                            ) : (
                                <Image.Fluid src={image.default} srcSet={image.set} sizes="" draggable={false} />
                            )}
                        </CompareItemStyles.Placeholder>
                        <SelectSwatch
                            availableColours={car.availableColours}
                            selectedColourCode={car.colourCode}
                            swatchSelectHeight={swatchSelectHeight}
                            setSwatchSelectHeight={setSwatchSelectHeight}
                            index={index}
                        />
                        <HighlightedSpecs
                            isPdf={isPdf}
                            car={car}
                            index={index}
                            engineSelectHeight={engineSelectHeight}
                            setEngineSelectHeight={setEngineSelectHeight}
                        />
                    </CompareItemStyles.Wrapper>
                );
            }}
        />
    );
};

export default CompareDetails;
